// App.js
import './App.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Login from './auth/Login';
import Consulta from './consulta/Consulta';
import Dashboard from './dashboard/Dashboard';
import Ofertaesim from './esim/Ofertaesim';
import CarruselOfertas from './ofertas/CarruselOfertas';
import AiraloOffers from './esim/AiraloOffers';
import NotificacionCorreo from  './esim/NotificacionCorreo';
import Esim from './esim/Esim';
import Footer from './layout/Footer';
import Mensajeria from './contact/Mensajeria';
import ProtectedRoute from './auth/ProtectedRoute';
import Cobertura from './cobertura/Cobertura';
import Notificaciones from './notificaciones/Notificaciones';
import Promos from './promos/Promos';
import Referidos from './referidos/Referidos';
import Tour from './tour/Tour';
import Paneltour from './tour/Paneltour';
import PushManager from './pwa/PushManager';
import MonkeyGame from './dashboard/MonkeyGame';
import MonkeyBoxing from './games/MonkeyBoxing';
import Grupos from './grupos/Grupos';
import CallbackSaldo from './dashboard/CallbackSaldo';
import CallbackRecarga from './consulta/CallbackRecarga';
import CallbackActivacion from './dashboard/CallbackActivacion';
import Vinculacion from './vinculacion/Vinculacion';

import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import logo from './assets/monkey512x512.png';
import { Menubar } from 'primereact/menubar';

// ==================== PWA Install Banner ====================
function InstallBanner() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showAndroid, setShowAndroid] = useState(false);
  const [showIOS, setShowIOS] = useState(false);
  const [showDesktop, setShowDesktop] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    // No mostrar si ya está instalada
    if (window.matchMedia('(display-mode: standalone)').matches) return;

    // Si lo cerró, volver a mostrar después de 7 días
    const dismissedAt = localStorage.getItem('pwa_dismissed');
    if (dismissedAt) {
      const days = (Date.now() - Number(dismissedAt)) / (1000 * 60 * 60 * 24);
      if (days < 7) return;
    }

    const ua = navigator.userAgent;
    const isIOS = /iPhone|iPad|iPod/.test(ua) && !window.MSStream;
    const isMobile = /Android|iPhone|iPad|iPod/i.test(ua);

    if (isIOS) {
      setShowIOS(true);
    } else if (!isMobile) {
      setShowDesktop(true);
    }

    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowAndroid(true);
      setShowDesktop(false);
    });
  }, []);

  const handleInstall = () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    deferredPrompt.userChoice.then(() => { setShowAndroid(false); setDismissed(true); });
  };

  const dismiss = () => {
    setShowAndroid(false);
    setShowIOS(false);
    setShowDesktop(false);
    setDismissed(true);
    localStorage.setItem('pwa_dismissed', String(Date.now()));
  };

  if (dismissed || (!showAndroid && !showIOS && !showDesktop)) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0,
      padding: expanded ? '20px 16px 24px' : '12px 16px',
      background: '#1a3a2a',
      color: '#fff', zIndex: 1001,
      borderRadius: '14px 14px 0 0',
      boxShadow: '0 -2px 16px rgba(0,0,0,0.2)',
      transition: 'padding 0.2s',
    }}>
      {/* Barra compacta */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}>
        <div
          onClick={() => !showAndroid && setExpanded(!expanded)}
          style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1, minWidth: 0, cursor: (showIOS || showDesktop) ? 'pointer' : 'default' }}
        >
          <span style={{ fontSize: 22 }}>📲</span>
          <span style={{ fontSize: 13, lineHeight: 1.3 }}>
            <strong>Instala MonkeyPhone</strong>
            {!expanded && (showIOS || (showDesktop && !showAndroid)) && <span style={{ color: 'rgba(255,255,255,0.5)', marginLeft: 6 }}>Toca para ver cómo</span>}
          </span>
        </div>
        <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
          {showAndroid && (
            <button onClick={handleInstall} style={{
              padding: '8px 16px', fontSize: 13, fontWeight: 700,
              background: '#22c55e', color: '#fff', border: 'none',
              borderRadius: 10, cursor: 'pointer',
            }}>
              Instalar
            </button>
          )}
          <button onClick={dismiss} style={{
            padding: '8px', background: 'transparent', border: 'none',
            color: 'rgba(255,255,255,0.5)', fontSize: 16, cursor: 'pointer',
          }}>✕</button>
        </div>
      </div>

      {/* Instrucciones expandidas */}
      {expanded && (
        <div style={{ marginTop: '14px', fontSize: 14, lineHeight: 1.8, color: 'rgba(255,255,255,0.9)' }}>
          {showIOS && (
            <>
              <p style={{ margin: '0 0 4px 0', fontWeight: 700 }}>En Safari:</p>
              <p style={{ margin: 0 }}>1. Toca el botón <strong>Compartir</strong> ⬆️ (abajo de la pantalla)</p>
              <p style={{ margin: 0 }}>2. Desliza y selecciona <strong>"Agregar a pantalla de inicio"</strong> ➕</p>
              <p style={{ margin: 0 }}>3. Toca <strong>"Agregar"</strong> arriba a la derecha</p>
            </>
          )}
          {showDesktop && !showAndroid && (
            <>
              <p style={{ margin: '0 0 4px 0', fontWeight: 700 }}>En tu navegador:</p>
              <p style={{ margin: 0 }}>1. Busca el ícono 📥 en la barra de direcciones</p>
              <p style={{ margin: 0 }}>2. O ve a <strong>Menú (⋮) → Instalar MonkeyPhone</strong></p>
            </>
          )}
        </div>
      )}
    </div>
  );
}

// ==================== Main App ====================
function App() {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [swRegistration, setSwRegistration] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      // Solo mostrar si hay un worker esperando
      if (e.detail && e.detail.waiting) {
        setSwRegistration(e.detail);
        setUpdateAvailable(true);
      }
    };
    window.addEventListener('swUpdate', handler);
    return () => window.removeEventListener('swUpdate', handler);
  }, []);

  const handleUpdate = () => {
    if (swRegistration && swRegistration.waiting) {
      swRegistration.waiting.postMessage({ type: 'SKIP_WAITING' });
      setUpdateAvailable(false);
      window.location.reload();
    }
  };
  // Hook de navegación de React Router
  const NavigationWrapper = () => {
    const navigate = useNavigate();

    const items = [
      { label: 'Recarga y Consulta Saldo', icon: 'pi pi-home', command: () => navigate('/Consulta') },
      { label: 'Ofertas', icon: 'pi pi-tags', command: () => navigate('/Ofertas') },
      { label: 'Compra de Esim Monkey', icon: 'pi pi-calculator', command: () => navigate('/Esim') },
      { label: 'Compra de Esim Internacional', icon: 'pi pi-calculator', command: () => navigate('/Ofertasinternacional') },
      { label: 'Cobertura', icon: 'pi pi-map-marker', command: () => navigate('/Cobertura') },
      { label: 'Mi Grupo', icon: 'pi pi-users', command: () => navigate('/Grupo') },
      { label: 'Promociones', icon: 'pi pi-images', command: () => navigate('/Promos') },
      { label: 'Invita a un amigo', icon: 'pi pi-users', command: () => navigate('/Referidos') },
      { label: '🎮 Jugar', icon: 'pi pi-play', items: [
          { label: '🐒 Monkey Runner', command: () => navigate('/Jugar') },
          { label: '🥊 Monkey Boxing', command: () => navigate('/Boxing') },
        ]
      },
      { label: 'Iniciar como vendedor', icon: 'pi pi-sign-in', command: () => navigate('/Login') },
      { label: 'Contacto', icon: 'pi pi-telegram', command: () => navigate('/Mensajeria') }
    ];

    const start = <img alt="Logo" src={logo} className="logo-responsive mr-2" />;

    return <Menubar model={items} start={start} style={{ backgroundColor: '#f0f7f2', borderBottom: '10px solid #1a3a2a', marginBottom: '20px' }} />;
  };

  // Service Worker se registra en index.js via serviceWorkerRegistration


  return (
    <div className="App">
      <Router>
        <NavigationWrapper />
        <Routes>
          <Route path="/" element={<Consulta />} />
          <Route path="/Consulta" element={<Consulta />} />
          <Route path="/Ofertaesim" element={<Ofertaesim />} />
          <Route path="/Ofertasinternacional" element={<AiraloOffers />} />
          <Route path="/Tour" element={<Tour />} />
          <Route path="/Paneltour" element={<Paneltour />} />
          <Route path="/Esim" element={<Esim />} />
          <Route path="/login" element={<Login />} />
          <Route path="/Mensajeria" element={<Mensajeria />} />
          <Route path="/Cobertura" element={<Cobertura />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/NotificacionCorreo" element={<NotificacionCorreo />} />
          <Route path="/Notificaciones" element={<Notificaciones />} />
          <Route path="/Promos" element={<Promos />} />
          <Route path="/Referidos" element={<Referidos />} />
          <Route path="/Jugar" element={<MonkeyGame />} />
          <Route path="/Boxing" element={<MonkeyBoxing />} />
          <Route path="/Grupo" element={<Grupos />} />
          <Route path="/Ofertas" element={<CarruselOfertas />} />
          <Route path="/callback-saldo" element={<CallbackSaldo />} />
          <Route path="/callback-recarga" element={<CallbackRecarga />} />
          <Route path="/callback-activacion" element={<CallbackActivacion />} />
          <Route path="/vinculacion" element={<Vinculacion />} />
        </Routes>

        {/* PWA Components */}
        <InstallBanner />
        <PushManager />

      </Router>
      <Footer />
      <ToastContainer />
      {updateAvailable && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0,
          padding: '14px 20px',
          background: '#0056b3', color: '#fff',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          zIndex: 2000, fontSize: 14,
        }}>
          <span>🔄 Nueva versión disponible</span>
          <button onClick={handleUpdate} style={{
            padding: '8px 20px', background: '#22c55e', color: '#fff',
            border: 'none', borderRadius: 8, fontWeight: 700, cursor: 'pointer',
          }}>
            Actualizar
          </button>
        </div>
      )}
    </div>
  );
}

export default App;
